import {submitBatchApi} from '../../api/enrichmentApi';
import {enrichWorkspaceApi} from '../../api/workspaceApi';

/** Workspace submissions redeem the quote for the same frozen IDs and model. */
export default async function submitAiEnrichmentBatch({
  companyIds, query, provider, model, draftSessionId, workspaceQuote,
}) {
  if (workspaceQuote) {
    const response = await enrichWorkspaceApi(workspaceQuote.workspaceId, {
      company_ids: companyIds,
      query,
      llm_provider: provider,
      model,
      quote_token: workspaceQuote.quoteToken,
    });
    if (response?.status !== 200) {
      const failure = new Error('AI enrichment could not start');
      failure.response = response;
      throw failure;
    }
    return response;
  }
  return submitBatchApi({
    company_ids: companyIds,
    query,
    llm_provider: provider,
    model,
    ...(draftSessionId ? {draft_session_id: draftSessionId} : {}),
  });
}
